import { parseJsonMap } from "./json-map";
import { parseLegacyMap } from "./legacy-map";
import { type MapDef, MapFormatError } from "./map-def";

export type { AsteroidSettings, FuelItemDef, MapDef, PlanetDef, PointDef } from "./map-def";
export { MapFormatError } from "./map-def";
export { parseJsonMap, parseLegacyMap };

/** Loads a map from file text, accepting both JSON maps and legacy `.map` files. */
export function loadMap(text: string, fallbackName: string): MapDef {
	if (text.trimStart().startsWith("{")) {
		let data: unknown;
		try {
			data = JSON.parse(text);
		} catch (err) {
			throw new MapFormatError(`${fallbackName}: invalid JSON (${(err as Error).message})`);
		}
		return parseJsonMap(data);
	}
	return parseLegacyMap(text, fallbackName);
}
export {
	CUSTOM_MAP_LIMITS,
	customMapProblems,
	parseCustomMap,
	SPAWN_CLEARANCE,
} from "./limits";
